import {BASE_URL} from "../../config/network";

const getVehicleAvailabilityAPI = async ({vehicleId, startDate, endDate}) => {
    const query = new URLSearchParams({
        start_date: startDate,
        end_date: endDate,
    });

    const URL = `${BASE_URL}/public/p2p/vehicle/${vehicleId}/availability?${query.toString()}`;
    const METHOD = "GET";
    const HEADERS = {
        Accept: "application/json",
        "Content-Type": "application/json",
    };

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
    });

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    return await response.json();
};

export {getVehicleAvailabilityAPI};
